var I64BIT_TABLE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_-'.split('');
import { Base64 } from 'js-base64';
import { getToken } from '@/web-framework/api/token';
import UserAPI from '@/web-framework/api/user.js';
import { Encoder, ErrorCorrectionLevel } from '@nuintun/qrcode';
import store from '@/public/store';
const MimeType = {
    VIDEO: [
        'video/wmv',
        'video/wm',
        'video/asf',
        'video/asx',
        'video/rm',
        'video/mpg',
        'video/mpeg',
        'video/3gp',
        'video/mp4',
        'video/rmvb',
        'video/mkv',
        'video/avi',
        'video/flv',
        'video/f4v',
        'video/x-ms-wmv'
    ],
    AUDIO: ['audio/'],
    IMAGE: ['image/jpeg', 'image/gif', 'image/png', 'image/tiff'],
    excel: ['image/jpeg', 'image/gif']
};

export var Utils = {
    login(vm) {
        vm.$login({ tab: 'login', closable: true });
    },
    regist(vm) {
        vm.$login({ tab: 'regist', closable: true });
    },
    doAfterLogin(vm, calback, closable, defaultTab) {
        // 检查用户是否登录了，如果未登录，则弹出登录对话框
        let p = new Promise((resolve, reject) => {
            if (store.getters.user && store.getters.user.id && store.getters.user.id.length > 0) {
                // 用户已登录
                resolve(true);
            } else {
                // 用户未登录，弹出登录对话框
                vm.$login({
                    closable: typeof closable == 'undefined' ? true : closable,
                    tab: typeof closable == 'undefined' ? 'login' : defaultTab,
                    // 登录后的回调
                    afterLogin: data => {
                        resolve(true);
                    },
                    afterRegister: data => {
                        resolve(true);
                    }
                });
            }
        });

        p.then(result => {
            if (result == true && calback) {
                try {
                    calback();
                } catch (error) {}
            } else {}
        }).catch(err => {});
    },
    /**
     * 获取文档预览的Url
     * @param {} suffix
     * @returns
     */
    getDocPreviewUrl(suffix) {
        let url = this.getResourceUrl(suffix);
        url = `${store.getters.siteInfo[window.Constants.Settings.DOC_SERVER]}/onlinePreview?url=${encodeURIComponent(Base64.encode(url))}`;
        return url;
    },
    getAvator(uid, size) {
        let filename = uid;
        if (size) filename = filename + '_' + size;
        filename += '.jpg';
        if (store.getters.siteInfo[window.Constants.Settings.AVATOR_SERVICE_ADDRESS]) {
            return `${store.getters.siteInfo[window.Constants.Settings.AVATOR_SERVICE_ADDRESS]}/avator/${filename}`;
        }
        return '';
    },
    getVideoPoster(resourceId, size) {
        let filename = resourceId;
        if (size) filename = filename + '_' + size;
        filename += '.jpg';
        if (store.getters.siteInfo[window.Constants.Settings.AVATOR_SERVICE_ADDRESS]) {
            return `${store.getters.siteInfo[window.Constants.Settings.AVATOR_SERVICE_ADDRESS]}/poster/${filename}`;
        }
        return '';
    },
    getResourceUrl(suffix) {
        if (typeof suffix == 'undefined' || suffix == null || suffix.length == 0) {
            return '';
        } else if (suffix.toLocaleLowerCase().startsWith('http://')) {
            return suffix;
        } else if (suffix.toLocaleLowerCase().startsWith('//')) {
            return suffix.substring(1);
        }

        if (store.getters.siteInfo.STORAGE_DOMAIN_NAME) {
            let prefix = store.getters.siteInfo.STORAGE_DOMAIN_NAME;
            if (prefix) {
                if (prefix.endsWith('/')) prefix = prefix.substring(0, prefix.length - 1);
            } else {
                prefix = '';
            }
            if (suffix.startsWith('/')) {
                suffix = suffix.substring(1, suffix.length);
            }
            return prefix + '/' + suffix;
        }
        return suffix;
    },
    removeEmptyStrInObject(obj) {
        let copyed = JSON.parse(JSON.stringify(obj));
        let keys = Object.keys(copyed);
        keys.forEach(item => {
            if (copyed[item] === '') delete copyed[item];
        });
        return copyed;
    },
    swapOrderInArray(array, index1, index2) {
        let p = array[index1];
        array[index1] = array[index2];
        array[index2] = p;
    },
    getItemInTree(array, childrenPropertyName, property, value) {
        let cur = function(item) {
            if (item[property] == value) return item;

            if (item[childrenPropertyName] && item[childrenPropertyName].length > 0) {
                for (let i = 0; i < item[childrenPropertyName].length; i++) {
                    let result = cur(item[childrenPropertyName][i]);
                    if (result) {
                        return result;
                    }
                }
            }
        };
        if (Array.isArray(array)) {
            for (let index = 0; index < array.length; index++) {
                let item = array[index];

                if (item[property] == value) return item;

                if (item[childrenPropertyName]) {
                    for (let i = 0; i < item[childrenPropertyName].length; i++) {
                        let result = cur(item[childrenPropertyName][i]);
                        if (result) {
                            return result;
                        }
                    }
                }
            }
        } else {
            if (array[childrenPropertyName]) {
                for (let i = 0; i < array[childrenPropertyName].length; i++) {
                    let result = cur(array[childrenPropertyName][i]);
                    if (result) return result;
                }
            }
        }
    },
    /**
     * 递归调用算法
     * @param {*} array
     * @param {*} childrenPropertyName
     * @param {*} callback
     */
    recursive(array, childrenPropertyName, callback) {
        let cur = function(item, array, index) {
            callback(item, array, index);
            if (item[childrenPropertyName] && item[childrenPropertyName].length > 0) {
                for (let i = 0; i < item[childrenPropertyName].length; i++) {
                    cur(item[childrenPropertyName][i], item[childrenPropertyName], i);
                }
            }
        };
        if (Array.isArray(array)) {
            array.forEach((item, index) => {
                callback(item, array, index);
                if (item[childrenPropertyName]) {
                    for (let i = 0; i < item[childrenPropertyName].length; i++) {
                        cur(item[childrenPropertyName][i], item[childrenPropertyName], i);
                    }
                }
            });
        } else {
            if (array[childrenPropertyName]) {
                for (let i = 0; i < array[childrenPropertyName].length; i++) {
                    cur(array[childrenPropertyName][i], array[childrenPropertyName], i);
                }
            }
        }
    },
    validatePassword(rule, value, callback) {
        if (this.isNull(value) || value.trim().length == 0) {
            callback(new Error('密码不能为空'));
            return;
        } else if (value.length < 4 || value.length > 30) {
            callback(new Error('密码长度不能少于4位，最多不超过30位。'));
            return;
        } else if (!/^[a-zA-Z0-9!_@]+$/.test(value)) {
            callback(new Error('密码只能是数字或字母或!或_或@'));
            return;
        }
        callback();
    },
    validateEmail(rule, value, callback) {
        if (value == '' || value == null || value == undefined) {
            return callback(new Error('请输入邮箱地址'));
        }
        if (value.length > 100) {
            return callback(new Error('最大长度为100，请重新输入'));
        }
        if (!this.CheckForm.checkEmail(value)) {
            return callback(new Error('邮箱地址格式不正确'));
        }
        callback();
    },
    validateLoginName(rule, value, callback) {
        if (value === '') {
            callback(new Error('用户名不能为空'));
            return;
        } else {
            if (!this.CheckForm.checkLoginName(value)) {
                callback(new Error('用户名必须以字母开头，并与数字组合，可包含"@"，"."，"_"，6-50字符'));
                return;
            }
        }
        callback();
    },
    validateCertificate(rule, value, callback) {
        if (value && value.length != 0) {
            if (!this.CheckForm.checkIdcard(value)) {
                return callback(new Error('身份证格式不正确'));
            }
        }
        callback();
    },
    validateBirthday(rule, value, callback) {
        if (value && new Date(value).getTime() >= new Date().getTime()) {
            return callback(new Error('生日不可选择今日之后的日期'));
        }
        callback();
    },
    validateDomainName(rule, value, callback) {
        let mattched = /(?=.*[a-zA-Z])([a-zA-Z]{1}([a-zA-Z0-9]|[-_]){1,30})$/.test(value);
        if (!mattched) {
            return callback(new Error('域名输入有误，必须为[英文字母、数字、”-“、”_“]，不能含有其他字符。'));
        }
        callback();
    },
    emptyValidator(rule, value, callback, emptyAlertMessage) {
        if (typeof value == 'undefined' || value.trim().length == 0) {
            callback(new Error(emptyAlertMessage));
            return;
        }
        callback();
    },
    getRequestParam(vm, name) {
        return vm.$route.params[name] ? vm.$route.params[name] : vm.$route.query[name];
    },
    encodeIdCard(str) {
        if (str.length >= 18) {
            let prefix = str.substring(0, 2);
            let suffix = str.substring(str.length - 2);
            return prefix + '**************' + suffix;
        }
        return str;
    },
    getUploadHeader(route) {
        return {
            authorization: getToken(),
            rid: UserAPI.getUserRole().id,
            model: route.name
        };
    },
    /**
     * 首字母大写
     */
    capitalize(str) {
        // 只需要一行代码即可
        let p = str.replace(str[0], str[0].toUpperCase());
        return p;
    },
    /**
     * 首字母小写
     */
    uncapitalize(str) {
        let p = str.replace(str[0], str[0].toLowerCase());
        return p;
    },
    checkBrowser() {
        var ua = navigator.userAgent.toLocaleLowerCase();
        var browserType = null;
        if (ua.match(/msie/) != null || ua.match(/trident/) != null) {
            browserType = 'IE';
            browserVersion = ua.match(/msie ([\d.]+)/) != null ? ua.match(/msie ([\d.]+)/)[1] : ua.match(/rv:([\d.]+)/)[1];
        } else if (ua.match(/firefox/) != null) {
            browserType = '火狐';
        } else if (ua.match(/ubrowser/) != null) {
            browserType = 'UC';
        } else if (ua.match(/opera/) != null) {
            browserType = '欧朋';
        } else if (ua.match(/bidubrowser/) != null) {
            browserType = '百度';
        } else if (ua.match(/metasr/) != null) {
            browserType = '搜狗';
        } else if (ua.match(/tencenttraveler/) != null || ua.match(/qqbrowse/) != null) {
            browserType = 'QQ';
        } else if (ua.match(/maxthon/) != null) {
            browserType = '遨游';
        } else if (ua.match(/chrome/) != null) {
            var is360 = _mime('type', 'application/vnd.chromium.remoting-viewer');

            function _mime(option, value) {
                var mimeTypes = navigator.mimeTypes;
                for (var mt in mimeTypes) {
                    if (mimeTypes[mt][option] == value) {
                        return true;
                    }
                }
                return false;
            }
            if (is360) {
                browserType = '360';
            } else {
                browserType = '谷歌';
            }
        } else if (ua.match(/safari/) != null) {
            browserType = 'Safari';
        }
        return browserType;
    },
    makeLocalSiteUrl(vm, domainPrefix) {
        if (!domainPrefix || domainPrefix.length == 0) {
            return vm.$store.getters.siteInfo.systemSetting.httpProtocal + '://' + vm.$store.getters.siteInfo.systemSetting.domainSuffix;
        } else {
            return vm.$store.getters.siteInfo.systemSetting.httpProtocal + '://' + domainPrefix + '.' + vm.$store.getters.siteInfo.systemSetting.domainSuffix;
        }
    },
    getPropertyValueInArray(array, propertyName, propertyValue, valueName) {
        if (typeof array == 'undefined' || array.length == 0) {
            return null;
        }

        let p = array.filter(el => {
            if (typeof el[propertyName] != 'undefined' && el[propertyName] == propertyValue) {
                return el;
            }
        });
        if (p.length > 0) {
            return p[0][valueName];
        }
    },
    /**
     * 过滤脏数据
     * @param str
     * @returns str
     */
    filterDirty(txtvalue) {
        let data = txtvalue;
        let list = JSON.parse(localStorage.getItem('sensitive'));
        list.forEach(ele => {
            var reg = new RegExp(ele.words, 'gi');
            data = data.replace(reg, '');
        });
        return data;
    },
    formatFloatString(str, len) {
        if (str == undefined) {
            return '0';
        }
        if (len == undefined) {
            len = 2;
        }
        let strVal = new String(str);
        if (strVal.indexOf('.') < 0) {
            return str;
        }

        try {
            if (str != undefined) {
                let num = new Number(str);
                return num.toFixed(len);
            } else {
                return '0';
            }
        } catch (err) {
            return 0;
        }
    },
    /**
     * 转换空字符串为null
     */
    convertEmptyString(obj) {
        let newObj = JSON.parse(JSON.stringify(obj));
        let keys = Object.keys(newObj);
        for (let k in keys) {
            if (newObj[keys[k]] == '') {
                newObj[keys[k]] = null;
            }
        }
        return newObj || {};
    },
    formatSecondsDurationToLabel(time) {
        // 转换为式分秒
        let h = parseInt((time / 60 / 60) % 24);
        h = h < 10 ? '0' + h : h;
        let m = parseInt((time / 60) % 60);
        m = m < 10 ? '0' + m : m;
        let s = parseInt(time % 60);
        s = s < 10 ? '0' + s : s;
        // 作为返回值返回
        return h + ':' + m + ':' + s;
    },
    getCurrentStartDayAndEndDay() {
        const date = new Date();
        // 设置为日期1号
        date.setDate(1);
        // 获取当前月份(date.getMonth()返回的是0-11)
        let month = parseInt(date.getMonth() + 1);
        // 获取当月第一天日期
        let startDay = date.getDate();
        // 获取当前月的最后一天。参数0代表上个月的最后一天
        const endOfMonth = new Date(date.getFullYear(), month, 0).getDate();
        // 设置日期为当前月的最后一天
        date.setDate(endOfMonth);
        // 获取当月最后一天日期
        let endDay = date.getDate();
        if (month < 10) month = '0' + month;
        if (startDay < 10) startDay = '0' + startDay;
        if (endDay < 10) endDay = '0' + endDay;
        const startTime = date.getFullYear() + '-' + month + '-' + startDay + ' ' + '08:00:00';
        const endTime = date.getFullYear() + '-' + month + '-' + endDay + ' ' + '08:00:00';
        return { startDay: startTime, endDay: endTime };
    },
    formatDate(time, format) {
        if (time == undefined) {
            return '';
        }
        // 判断是否是数字类型
        if (typeof time === 'number' && !isNaN(time)) {
            time = new Date(time);
        }

        if (typeof time == 'string') {
            return this.formatString2Date(time, format);
        }

        var date = {
            'M+': time.getMonth() + 1,
            'd+': time.getDate(),
            'h+': time.getHours(),
            'm+': time.getMinutes() > 9 ? time.getMinutes() : '0' + time.getMinutes(),
            's+': time.getSeconds() > 9 ? time.getSeconds() : '0' + time.getSeconds(),
            'S+': time.getMilliseconds() //毫秒数
        };
        if (/(y+)/i.test(format)) {
            format = format.replace(RegExp.$1, (time.getFullYear() + '').substr(4 - RegExp.$1.length));
        }
        for (var k in date) {
            if (new RegExp('(' + k + ')').test(format)) {
                format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? date[k] : ('00' + date[k]).substr(('' + date[k]).length));
            }
        }
        return format;
    },
    formatString2Date(str, pattern) {
        if (str == undefined) {
            return '';
        }
        let time = new Date(str);
        return this.formatDate(time, pattern);
    },
    /**
     * 判断字符串是否为空
     * @returns {boolean}
     */
    isEmptyString(str) {
        return str == undefined || str.trim().length == 0;
    },
    /**
     * 判断是否字符串
     */
    isString(obj) {
        //判断对象是否是字符串
        return Object.prototype.toString.call(obj) === '[object String]';
    },
    nullDefault(obj, defalutValue) {
        return this.isNull(obj) ? defalutValue : obj;
    },
    isNull(obj) {
        return typeof obj === 'undefined' || obj === null;
    },
    notNull(obj) {
        let isNull = typeof obj != 'undefined' && obj != null;
        if (!isNull && Array.isArray(obj)) {
            return obj.length == 0;
        }
        return isNull;
    },
    enableSiteParam(vm, paramName) {
        return typeof vm.$store.getters.paramsSetting(paramName) != 'undefined' && vm.$store.getters.paramsSetting(paramName).value == vm.Constants.Yes;
    },
    enableOrIsEmptySiteParam(vm, paramName) {
        let p =
            (typeof vm.$store.getters.paramsSetting(paramName) != 'undefined' &&
                (vm.$store.getters.paramsSetting(paramName).value == vm.Constants.Yes || typeof vm.$store.getters.paramsSetting(paramName).value == 'undefined')) ||
            typeof vm.$store.getters.paramsSetting(paramName) == 'undefined';
        return p;
    },
    keepBit(f, bit) {
        return f.toFixed(bit);
    },
    formatParam(str, params) {
        if (params.length > 0) {
            params.forEach(el => {
                let keys = Object.keys(el);
                keys.forEach(elkey => {
                    str = str.replaceAll('${' + elkey + '}', el[elkey]);
                });
            });
        }
        return str;
    },

    /**
     * 判断是否整数
     * @param value
     * @returns {boolean}
     */
    isInteger(value) {
        return !isNaN(value) && parseInt(Number(value)) == value && !isNaN(parseInt(value, 10));
    },
    safeInt(value) {
        if (this.isNull(value)) return 0;

        if (this.isString(value)) {
            let p = value.trim();
            if (p.length == 0) {
                return 0;
            } else {
                return parseInt(p);
            }
        } else if (this.isString(value)) {
            return value;
        } else return value;
    },

    /**
     * 数组中元素上移
     * @param {} arry
     * @param {*} index1
     */
    arrayElementMoveUp(array, index) {
        if (index == 0) {
            return;
        }

        let obj = array[index];
        array.splice(index, 1);
        array.splice(index - 1, 0, obj);
    },

    arrayElementMoveDown(array, index) {
        if (array.length == index + 1) {
            return;
        }

        let obj = array[index];
        array.splice(index, 1);
        array.splice(index + 1, 0, obj);
    },
    /**
     * 判断是否数组
     * @param obj
     * @returns {boolean}
     */
    isArray(obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    },
    /**
     * 过滤数组
     * @param array
     * @param prop
     * @param value
     */
    filterArray(array, prop, value) {
        var result = array.filter(function(el) {
            if (el[prop] == value) return el;
        });
        return result;
    },
    /**
     * 过滤数组
     * @param array
     * @param prop
     * @param value
     */
    filterIndex(array, prop, value) {
        let index = -1;
        for (let i = 0; i < array.length; i++) {
            if (array[i][prop] == value) {
                index = i;
                break;
            }
        }
        return index;
    },

    /**
     * list转Map
     * @param array
     * @param propName
     * @returns {{}}
     */
    list2map(array, propName) {
        var obj = {};
        array.map(function(a) {
            obj[a[propName]] = a;
        });
        return obj;
    },

    /**
     * 拷贝对象属性
     * @param obj
     * @returns {{}}
     */
    copyObjectProperty(obj) {
        var dest = {};
        for (var p in obj) {
            if (obj.hasOwnProperty(p)) {
                dest[p] = obj[p];
            }
        }
        return dest;
    },
    /**
     * 产生一个随机数
     */
    generateRandomCode: function() {
        var r = Math.random() * 100000;
        return r;
    },
    /**
     * 产生一个随机数
     */
    generate4BitRandomCode: function() {
        var r = Math.floor(Math.random() * 10000);
        return r;
    },

    /**
     * 对URL处理的工具函数
     */
    URL: {
        isNull(obj) {
            return typeof obj === 'undefined' || obj === null;
        },
        lastSlash: function(url) {
            var str = this.isNull(url) ? window.location.href : url;
            var index = str.lastIndexOf('/');
            str = str.substring(index + 1, str.length);
            var idx = str.indexOf('?');
            if (idx > 0) str = str.substring(0, idx);
            return str;
        },
        getParameter: function(name) {
            if (this.isNull(name)) {
                var index = window.location.href.lastIndexOf('/');
                return window.location.href.substring(index + 1);
            } else {
                var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
                var r = window.location.search.substr(1).match(reg);
                if (r != null) return unescape(r[2]);
                return null;
            }
        }
    },
    Browser: {
        isMSEdgeBrowser: function() {
            // IE11 /IE Edge
            if (/rv:11.0./i.test(navigator.userAgent)) {
                return true;
            }
            return false;
        },

        /**
         * 判断是否IE浏览器
         * @returns {boolean}
         */
        isIe() {
            if (!!window1.ActiveXObject || 'ActiveXObject' in window1) return true;
            else return false;
        }
    },

    Date: {},
    /**
     * 返回顶部
     */
    scrollTops(window1, scrollTop, type) {
        // typ：false 直接返回 true带过渡
        if (!type) {
            window1.scrollTo(0, scrollTop);
        } else {
            // 清空上一次的定时器
            let timer = null;
            clearInterval(timer);
            // 创建定时器，每 0ms 执行一次箭头函数
            timer = setInterval(() => {
                scrollTop -= scrollTop / 30;
                window1.scrollTo(0, scrollTop);
                if (scrollTop < 2) {
                    window1.scrollTo(0, 0);
                    clearInterval(timer);
                }
            }, 0);
        }
    },
    /**
     * 返回上一级路由，页面滚动位置恢复，handleScroll、addScroll、removeScroll
     */
    handleScroll() {
        window.scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    },
    addScroll() {
        window.addEventListener('scroll', this.handleScroll, true);
    },
    removeScroll() {
        window.removeEventListener('scroll', this.handleScroll, true);
    },
    /**
     *  全局loading加载
     */
    globalLoading(self, text = '正在加载中,请稍等...') {
        self.loadingClose = self.$loading({
            lock: true,
            text: text,
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
    },
    groupby(list, propertyName) {
        let map = {};
        list.forEach(item => {
            if (!map[item[propertyName]]) {
                map[item[propertyName]] = [];
            }
            map[item[propertyName]].push(item);
        });
        return map;
    },
    uuid() {
        var s = [];
        var hexDigits = '0123456789abcdef';
        for (var i = 0; i < 36; i++) {
            s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
        }
        s[14] = '4';
        s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
        s[8] = s[13] = s[18] = s[23] = '_';

        this.uuidA = s.join('');
        return this.uuidA;
    },
    createTimesatamp(l) {
        let len = l || 32;
        var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
        /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
        var maxPos = $chars.length;
        var pwd = '';
        for (let i = 0; i < len; i++) {
            pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
        }
        return pwd;
    },
    createAjaxTimestamp() {
        let stamp = this.createTimesatamp(32);
        let time = Date.parse(new Date());
        return stamp + time;
    },
    /**
     * Judge param is empty Object
     * @param {json} param
     */
    isEmptyObj(param) {
        if (param) {
            return '{}' === JSON.stringify(param);
        } else {
            return true;
        }
    },
    isNotSupportBro() {
        var DEFAULT_VERSION = 8.0;
        var ua = navigator.userAgent.toLowerCase();
        var isIE = ua.indexOf('msie') > -1;
        var safariVersion;
        if (isIE) {
            safariVersion = ua.match(/msie ([\d.]+)/)[1];
            if (safariVersion <= DEFAULT_VERSION) {
                return true;
            }
        }
        return false;
    },
    CheckForm: {
        checkLoginName: function(value) {
            return /^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z]{1}([a-zA-Z0-9]|[@._]){5,49})$/.test(value);
        },
        checkPhone: function(value) {
            return /^1[3456789]\d{9}$/.test(value);
        },
        checkEmail: function(value) {
            return /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(value);
        },
        checkIdcard(idCard) {
            var initCityMap = function() {
                var cityMap = new Map();
                cityMap.set('11', '北京');
                cityMap.set('12', '天津');
                cityMap.set('13', '河北');
                cityMap.set('14', '山西');
                cityMap.set('15', '内蒙古');

                cityMap.set('21', '辽宁');
                cityMap.set('22', '吉林');
                cityMap.set('23', '黑龙江');

                cityMap.set('31', '上海');
                cityMap.set('32', '江苏');
                cityMap.set('33', '浙江');
                cityMap.set('34', '安徽');
                cityMap.set('35', '福建');
                cityMap.set('36', '江西');
                cityMap.set('37', '山东');

                cityMap.set('41', '河南');
                cityMap.set('42', '湖北');
                cityMap.set('43', '湖南');
                cityMap.set('44', '广东');
                cityMap.set('45', '广西');
                cityMap.set('46', '海南');

                cityMap.set('50', '重庆');
                cityMap.set('51', '四川');
                cityMap.set('52', '贵州');
                cityMap.set('53', '云南');
                cityMap.set('54', '西藏');

                cityMap.set('61', '陕西');
                cityMap.set('62', '甘肃');
                cityMap.set('63', '青海');
                cityMap.set('64', '宁夏');
                cityMap.set('65', '新疆');

                cityMap.set('81', '香港');
                cityMap.set('83', '台湾');
                cityMap.set('82', '澳门');
                // cityMap.set("91", "国外");
                return cityMap;
            };
            var prefix = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
            var suffix = [1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2];
            if (/^(\d{6})(19|20)(\d{2})(1[0-2]|0[1-9])(0[1-9]|[1-2][0-9]|3[0-1])(\d{3})(\d|X|x)$/.test(idCard)) {
                var cityMap = initCityMap();
                if (!cityMap.get(idCard.substring(0, 2))) {
                    return false;
                }
                var idCardWiSum = 0; //用来保存前17位各自乖以加权因子后的总和
                for (var i = 0; i < 17; i++) {
                    idCardWiSum += parseInt(idCard.substring(i, i + 1)) * prefix[i];
                }
                var idCardMod = idCardWiSum % 11; //计算出校验码所在数组的位置
                var idCardLast = idCard.substring(17); //得到最后一位身份证号码

                //如果等于2，则说明校验码是10，身份证号码最后一位应该是X
                if (idCardMod == 2) {
                    if (idCardLast.toLowerCase() == 'x') {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    //用计算出的验证码与最后一位身份证号码匹配，如果一致，说明通过，否则是无效的身份证号码
                    if (idCardLast == suffix[idCardMod] + '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
            return false;
        }
    },
    // 去除HTML标记
    clearHtmlTags(text) {
        if (!text) return '';
        else return text.replace(/<[^>]*>/g, '').replace(/&nbsp;/gi, ''); //去除文字的<...></...>标签
    },
    HTMLDecode: function(text) {
        var temp = document.createElement('div');
        temp.innerHTML = text;
        var output = temp.innerText || temp.textContent;
        temp = null;
        return output;
    },
    emptyFunction() {},

    matchRoot(vm, path) {
        let routerPath = vm.$route.path;
        if (new RegExp(eval('/' + path + '/g')).test(routerPath)) {
            return true;
        } else {
            return false;
        }
    },

    /**
     * 生成字符串的hash值
     * @param str
     * @returns {number}
     */
    hash(str) {
        var hash = 1315423911,
            i,
            ch;
        for (i = str.length - 1; i >= 0; i--) {
            ch = str.charCodeAt(i);
            hash ^= (hash << 5) + ch + (hash >> 2);
        }
        return hash & 0x7fffffff;
    },

    /**
     * 检测密码强度
     * @param sValue
     * @returns {number}
     */
    checkPasswordStrong(sValue) {
        var modes = 0;
        //正则表达式验证符合要求的
        if (sValue.length < 1) return modes;
        if (/\d/.test(sValue)) modes++; //数字
        if (/[a-z]/.test(sValue)) modes++; //小写
        if (/[A-Z]/.test(sValue)) modes++; //大写
        if (/\W/.test(sValue)) modes++; //特殊字符

        //逻辑处理
        switch (modes) {
            case 1:
                return 1;
                break;
            case 2:
                return 2;
                break;
            case 3:
            case 4:
                return sValue.length < 10 ? 3 : 4;
                break;
        }
        return modes;
    },

    /**
     * 验证密码
     * @returns {boolean}
     */
    isValidPassword(s) {
        var patrn = /^[a-zA-Z0-9\_]{6,20}$/;
        if (!patrn.exec(s)) {
            return false;
        } else {
            return true;
        }
    },

    /**
     * 对数组进行排序
     * @param propertyName -- 数组中元素的属性名
     * @param isDesc -- 是否降序排序，默认是升序
     * @returns {Function}
     */
    sort(propertyName, isDesc) {
        return function(a, b) {
            var value1 = a[propertyName];
            var value2 = b[propertyName];
            if (isDesc == true) {
                // 升序排列
                return value1 - value2;
            } else {
                // 降序排列
                return value2 - value1;
            }
        };
    },
    arrayToObj(array, propertyName, value, valuePropertyName2) {
        let obj = {};
        array.forEach(el => {
            obj[el[propertyName]] = value ? el.value : el;
            if (typeof obj[el[propertyName]] == 'undefined' && typeof valuePropertyName2 != 'undefined') {
                obj[el[propertyName]] = el[valuePropertyName2];
            }
        });
        return obj;
    },
    createRules(fields) {
        let rules = {};
        if (!fields || typeof fields !== 'object') {
            return {};
        }
        fields.forEach(ele => {
            rules[ele.name] = this.createSingleRulesByField(ele);
        });
        return rules;
    },
    createSingleRules(fields, name) {
        if (!fields || typeof fields !== 'object') {
            return {};
        }
        let field = this.getFieldByName(fields, name);
        if (!field) {
            return;
        }

        let rules = this.createSingleRulesByField(field);

        return rules;
    },
    formatFileSize(size) {
        if (size < 1024) {
            return size + '字节';
        } else if (size < 1024 * 1024) {
            return (size / 1024).toFixed(2) + 'KB';
        } else if (size < 1024 * 1024 * 1024) {
            return (size / 1024 / 1024).toFixed(2) + 'MB';
        } else if (size < 1024 * 1024 * 1024 * 1024) {
            return (size / 1024 / 1024 / 1024).toFixed(2) + 'GB';
        } else if (size < 1024 * 1024 * 1024 * 1024 * 1024) {
            return (size / 1024 / 1024 / 1024 / 1024).toFixed(2) + 'TB';
        }
    },
    secondToMinutes(seconds) {
        return (seconds / 60).toFixed(2);
    },
    createSingleRulesByField(field) {
        if (!field || typeof field !== 'object') {
            return {};
        }

        let rules = [];
        switch (field.widgetType) {
            case 'SingleLineText':
            case 'MultiLineText':
            case 'RichTextEditor':
                rules = [{
                        required: field.required,
                        message: `请输入${field.label}`,
                        trigger: 'blur'
                    },
                    {
                        min: field.minLength,
                        max: field.maxLength,
                        message: `长度在 ${field.minLength} 到 ${field.maxLength} 个字符`,
                        trigger: 'blur'
                    }
                ];
                break;
            case 'Number':
                rules = [{
                        required: field.required,
                        message: `请输入${field.label}`,
                        trigger: 'blur'
                    },
                    {
                        type: 'number',
                        message: `请输入${field.label}`,
                        trigger: 'blur'
                    }
                ];
                break;
            case 'Radio':
            case 'CheckBox':
            case 'Date':
            case 'DateTime':
            case 'DropdownSelect':
                rules = [{
                    required: field.required,
                    message: `请输入${field.label}`,
                    trigger: 'change'
                }];
                break;
            case 'SingleImageUpload':
                rules = [{ required: field.required, message: `请选择${field.label}图片`, trigger: 'change' }];
                break;
        }
        return rules;
    },
    getFieldByName(fields, name) {
        let tempArr = fields.filter(ele => {
            return ele.name == name;
        });
        if (tempArr.length > 0) {
            return tempArr[0];
        } else {
            return null;
        }
    },
    /**
     * 非0的空值判断，当值为非0的false时返回true
     */
    isFalse(value) {
        if (value) {
            return false;
        } else if (value === 0) {
            return false;
        } else {
            return true;
        }
    },

    /**
     * 打印
     * @functionName: print
     * @param: {string} printConentId 要打印内容的外层id,不传则默认整页打印
     * @description:
     * @author: hiBruce
     * @date: 2020-04-29 13:59:59
     * @version: V1.0.0
     */
    print(printConentId) {
        if (printConentId) {
            if (document.getElementById('print-iframe')) {
                document.body.removeChild(document.getElementById('print-iframe'));
            }
            var el = document.getElementById(printConentId);
            let iframe = document.createElement('IFRAME');
            var doc = null;
            iframe.setAttribute('id', 'print-iframe');
            iframe.setAttribute('style', 'position:absolute;width:0px;height:0px;left:-500px;top:-500px;');
            document.body.appendChild(iframe);
            doc = iframe.contentWindow.document;
            //这里可以自定义样式
            //doc.write("<LINK rel="stylesheet" type="text/css" href="css/print.css">");
            doc.write('<div>' + el.innerHTML + '</div>');
            doc.close();
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
            if (navigator.userAgent.indexOf('MSIE') > 0) {
                document.body.removeChild(iframe);
            }
        } else {
            window.print();
        }
    },
    getDateInterval(date1, date2) {
        return (date2.getTime() - date1.getTime()) / (1000 * 60 * 60 * 24);
    },
    getMinutesInterval(date1, date2) {
        return (date2.getTime() - date1.getTime()) / (1000 * 60);
    },
    checkFileSize(file, maxSize) {
        return file.size - maxSize;
    },
    isAudio(file) {
        let fileType = file.type;
        let prefix = fileType.substring(fileType.indexOf('/'));
        return MimeType.AUDIO.indexOf(prefix) >= 0;
    },
    isVideo(filenameSuffix) {
        if (!filenameSuffix) return false;
        for (let i = 0; i < MimeType.VIDEO.length; i++) {
            if (MimeType.VIDEO[i].indexOf(filenameSuffix) != -1) return true;
        }
        return false;
    },
    isImage(file) {
        let fileType = file.type;
        for (let i = 0; i < MimeType.IMAGE.length; i++) {
            if (fileType.startsWith(MimeType.IMAGE[i])) {
                return true;
            }
        }
        return false;
    },
    /**
     * 对树节点的排序调整
     * @param {树对象} tree
     * @param {拖动的节点} draggingNode
     * @param {目标节点} dropNode
     * @param {拖拽类型} dropType
     * @param {需要调整的数组} array
     * @param {子数据属性名称} childrenProperty
     * @param {排序的的属性名称} sortProperty
     * @returns {sourceData : sourceData, sorts: sorts}
     */
    treeSort(tree, draggingNode, dropNode, dropType, array, childrenProperty, sortProperty) {
        let sourceData = draggingNode.data;
        let targetData = dropNode.data;

        // 重新设置parentId
        if (dropType == 'inner') {
            sourceData.parentId = targetData.id;
        } else {
            sourceData.parentId = targetData.parentId;
        }

        // 取得父节点
        let modifiedArray = [];
        let sourceParent = tree.getNode(sourceData.parentId);
        let tagetParent = tree.getNode(targetData.parentId);
        if ((!sourceParent && !tagetParent) || (sourceParent && tagetParent && sourceParent.data.id == tagetParent.data.id)) {
            // 同级节点移动
            // 取得新数组内容
            if (!sourceParent && !tagetParent) {
                // 对根节点的重排顺序
                modifiedArray = array.map((el, index) => {
                    el[sortProperty] = index;
                    let o = {
                        id: el.id
                    };
                    o[sortProperty] = index;
                    return o;
                });
            } else {
                // 对子节点的重排顺序
                let parentData = sourceParent.data;
                modifiedArray = parentData[childrenProperty].map((el, index) => {
                    el[sortProperty] = index;
                    let o = {
                        id: el.id
                    };
                    o[sortProperty] = index;
                    return o;
                });
            }
        } else {
            // 不同级节点移动
            if (sourceParent && tagetParent) {
                let sourceModifiedArray = sourceParent.data[childrenProperty].map((el, index) => {
                    el[sortProperty] = index;
                    let o = {
                        id: el.id
                    };
                    o[sortProperty] = index;
                    return o;
                });
                let targetModifiedArray = tagetParent.data[childrenProperty].map((el, index) => {
                    el[sortProperty] = index;
                    let o = {
                        id: el.id
                    };
                    o[sortProperty] = index;
                    return o;
                });
                modifiedArray = modifiedArray.concat(sourceModifiedArray, targetModifiedArray);
            } else if (sourceParent && !tagetParent) {
                let sourceModifiedArray = sourceParent.data[childrenProperty].map((el, index) => {
                    el[sortProperty] = index;
                    let o = {
                        id: el.id
                    };
                    o[sortProperty] = index;
                    return o;
                });
                let targetModifiedArray = array[childrenProperty].map((el, index) => {
                    el[sortProperty] = index;
                    let o = {
                        id: el.id
                    };
                    o[sortProperty] = index;
                    return o;
                });
                modifiedArray = modifiedArray.concat(sourceModifiedArray, targetModifiedArray);
            } else if (!sourceParent && tagetParent) {
                let sourceModifiedArray = array[childrenProperty].map((el, index) => {
                    el[sortProperty] = index;
                    let o = {
                        id: el.id
                    };
                    o[sortProperty] = index;
                    return o;
                });
                let targetModifiedArray = tagetParent.data[childrenProperty].map((el, index) => {
                    el[sortProperty] = index;
                    let o = {
                        id: el.id
                    };
                    o[sortProperty] = index;
                    return o;
                });
                modifiedArray = modifiedArray.concat(sourceModifiedArray, targetModifiedArray);
            }
        }
        return {
            sourceData: sourceData,
            sorts: modifiedArray
        };
    },
    initCKEditorField(id, content,options) {
        CKEDITOR.instances[id] && CKEDITOR.instances[id].destroy();
        CKEDITOR.replace(id, options || {});
        if (content) {
            CKEDITOR.instances[id].setData(content);
        }
    },

    noToChinese(num) {
        if (!/^\d*(\.\d*)?$/.test(num)) {
            alert('Number is wrong!');
            return 'Number is wrong!';
        }
        var AA = new Array('零', '一', '二', '三', '四', '五', '六', '七', '八', '九');
        var BB = new Array('', '十', '百', '千', '万', '亿', '点', '');
        var a = ('' + num).replace(/(^0*)/g, '').split('.'),
            k = 0,
            re = '';
        for (var i = a[0].length - 1; i >= 0; i--) {
            switch (k) {
                case 0:
                    re = BB[7] + re;
                    break;
                case 4:
                    if (!new RegExp('0{4}\\d{' + (a[0].length - i - 1) + '}$').test(a[0])) re = BB[4] + re;
                    break;
                case 8:
                    re = BB[5] + re;
                    BB[7] = BB[5];
                    k = 0;
                    break;
            }
            if (k % 4 == 2 && a[0].charAt(i + 2) != 0 && a[0].charAt(i + 1) == 0) re = AA[0] + re;
            if (a[0].charAt(i) != 0) re = AA[a[0].charAt(i)] + BB[k % 4] + re;
            k++;
        }
        if (a.length > 1) {
            //加上小数部分(如果有小数部分)
            re += BB[6];
            for (var i = 0; i < a[1].length; i++) re += AA[a[1].charAt(i)];
        }
        if (re == '一十') {
            re = '十';
        }
        return re;
    },
    getDifficultTagStyle(difficult) {
        let styles = ['primary', 'warning', 'danger'];
        return styles[Number(difficult) - 1];
    },
    getParentRoutePath(vm) {
        let path = vm.$route.path;
        let index = path.lastIndexOf('/');
        return path.substring(0, index + 1);
    },
    /**
     * 将一个数组按照另一个数组定义的顺序进行排序
     * @param {*} array
     * @param {*} propertyName
     * @param {*} array
     */
    sortbyArray(array, propertyName, sortArray) {
        let newArray = [];
        sortArray.forEach(item => {
            for (let i = 0; i < array.length; i++) {
                if (array[i][propertyName] == item) {
                    newArray.push(array[i]);
                    break;
                }
            }
        });
        return newArray;
    },
    /**
     * 获取app-main-inner的高度
     * @param {*} vm
     * @param {*} callback
     */
    getAppMainInnerHeight(vm, callback) {
        vm.$nextTick(() => {
            let dom = document.getElementsByClassName('app-main-inner')[0];
            callback(dom.clientHeight);
        });
    },
    createQrImage(url) {
        let qrcode = new Encoder();
        qrcode.setEncodingHint(true);
        qrcode.setErrorCorrectionLevel(ErrorCorrectionLevel.H);
        qrcode.write(url);
        qrcode.make();
        return qrcode.toDataURL(4);
    },
    /**
     * @description: 从options数组中查询到达id这个值的全部路径。用于当只知道子节点id，而需要查询出父节点id形成一整个数组的情况。一般用于cascader组件。
     * @param {*} options 数组
     * @param {*} id 最后一级的id
     * @return {*}
     */
    findPath(options, propName, id) {
        for (const option of options) {
            if (option[propName] === id) {
                return [option[propName]];
            } else if (option.children && option.children.length > 0) {
                const childPath = this.findPath(option.children, propName, id);
                if (childPath) {
                    return [option[propName], ...childPath];
                }
            }
        }
        return null;
    },
    Template_table_loadTableDatas(vm, pageNo, apiMethod, cb, paramsFunc) {
        vm.listQuery.pageNo = typeof pageNo == 'undefined' ? vm.listQuery.pageNo : pageNo;
        vm.listLoading = true;
        let fun = paramsFunc ? apiMethod(...paramsFunc()) : apiMethod(vm.listQuery);
        fun.then(result => {
            vm.listLoading = false;
            Request.validateResult(result, () => {
                vm.tableDatas = result.data || [];
                if (result.page) {
                    Vue.set(vm.listQuery, 'rowCount', result.page.rowCount);
                    Vue.set(vm.listQuery, 'totalPage', result.page.totalPage);
                }
                if (cb)
                    cb();
            });
        }).catch(error => {
            vm.listLoading = false;
            Request.validateCatchError(error);
        });
    },
    Template_table_remove(vm, item, apiMethod, paramsFunc) {
        this.deleteConfirm(vm, () => {
            let p = paramsFunc ? apiMethod(...paramsFunc()) : apiMethod(item.id);
            p.then(result => {
                Request.validateResult(result, () => {
                    vm.$message.success('删除成功');
                    vm.loadTableDatas();
                });
            }).catch(error => {
                Request.validateCatchError(error);
            });
        });
    },
    Template_table_batchRemove(vm, selections, apiMethod, paramsFunc) {
        if (!this.AssertMultiSelctions(vm, selections)) return;

        let p = paramsFunc ? apiMethod(...paramsFunc()) : apiMethod(selections);

        this.batchDeleteConfirm(vm, () => {
            vm.listLoading = true;
            p.then(result => {
                vm.listLoading = false;
                Request.validateResult(result, () => {
                    vm.$message.success("删除成功！");
                    vm.loadTableDatas();
                });
            }).catch(error => {
                vm.listLoading = false;
                Request.validateCatchError(error);
            });
        });
    },
    AssertMultiSelctions(vm, selections) {
        if (selections.length == 0) {
            vm.$message.error("未选择数据");
            return false;
        }
        return true;
    },
    deleteConfirm(vm, cb) {
        vm.$confirm('确定要删除该条记录吗？', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            cb();
        }).catch(() => {});
    },
    batchDeleteConfirm(vm, cb) {
        vm.$confirm('确定要批量删除选中的记录吗？', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            cb();
        }).catch(() => {});
    }
};